export const getTableId = (userId: number, profileId: number): string =>
    userId + '/' + profileId;
